/** Intervallo di date (yyyy-mm-dd) dei grafici statistici. */
export interface ChartRange {
  from: string
  to: string
}

const iso = (d: Date): string =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`

/** Intervallo per i grafici: i filtri vuoti (tutto lo storico) diventano gli ultimi 12 mesi. */
export function chartRange(from?: string, to?: string): ChartRange {
  const end = to || iso(new Date())
  if (from) return { from, to: end }
  const d = new Date(end + 'T00:00:00')
  d.setFullYear(d.getFullYear() - 1)
  d.setDate(d.getDate() + 1)
  return { from: iso(d), to: end }
}
